module.exports = __webpack_public_path__ + "media/images/svg-icon/advanced-15996ea4d7871876de7331a642630231.svg";